import { useContext } from "react";

import StyledContentPanel from '~/components/StyledContentPanel';
import { AppContext } from '~/contexts/AppContext';
import { MenuScreen } from '~/App';
import StyledButton from '~/components/StyledButton';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { useTranslation } from "react-i18next";

import { availableLanguages } from "../i18n/languages";

const LanguageScreen: React.FC = () => {
    const { i18n, t } = useTranslation();
    const { setMenuScreen } = useContext(AppContext)!;

    const chooseLanguage = (languageCode: string) => {
        i18n.changeLanguage(languageCode);
        setMenuScreen(MenuScreen.MainMenu);
    };

    return (
        <div style={{ padding: '20px'}}>
            <StyledContentPanel style={{ marginBottom: '20px' }}>
                <h1>{t('menu_language_title')}</h1>
            </StyledContentPanel>
            <StyledButton onClick={() => setMenuScreen(MenuScreen.MainMenu)}>
                <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faArrowLeft} /></span>
                {t('button_back')}
            </StyledButton>
            {Object.values(availableLanguages).map((language) => (
                <StyledButton key={language.code} onClick={() => chooseLanguage(language.code)}>
                    {language.displayName}
                </StyledButton>
            ))}
        </div>
    );
};

export default LanguageScreen;